// @flow
import React from 'react';
import { Modal } from '@wh/modal-component';
import { LoginComponent } from '@wh/login-component';
import { Spinner } from '@wh/ui-components';
import { TranslatorProvider } from '@wh/ui-translations';
import { subscribe } from '@wh/message-bus';
import defaultTranslation, { transformLangCode } from '../translations';
import * as constants from '../constants';

type LoginWrapperPropsType = {
    casUrl: string,
    service: string,
    modalClassName: string,
    overlayClassName: string,
    loginClassName: string,
    modalName: string,
    translations: { [key: string]: string },
    activeLanguageCode: string,
    recoverLoginUrl: string,
    openModal: () => void,
};

type LoginWrapperStateType = {
    isLoading: boolean;
}

const getDefaultTranslation = (activeLangCode: string) => {
    const code = transformLangCode(activeLangCode);
    return defaultTranslation[code] ? defaultTranslation[code] : defaultTranslation.en_gb;
};

/**
 * Login Component
 * Creates methods for external Login Form Modal usage (non-npm environment)
 * @returns {Element} React element
 */
class LoginWrapper extends React.Component {
    constructor(props: Object, context: Object) {
        super(props, context);
        this.state = {
            isLoading: true,
        };
    }

    state: LoginWrapperStateType;

    componentDidMount() {
        subscribe(constants.MESSAGE_SUB_LOGIN_BUTTON_CLICKED, () => this.props.openModal(this.props.modalName));
    }

    props: LoginWrapperPropsType;

    removeCloseBtn(url: string) {
        return url ? `${url}?closeBtn=false` : '';
    }

    iframeLoaded: Function = (): void => {
        this.setState({
            isLoading: false,
        });
    };

    accountRecoveryModalClosed: Function = (): void => {
        this.setState({
            isLoading: true,
        });
    };

    render() {
        const {
            casUrl = '',
            service = '',
            modalClassName = '',
            overlayClassName = '',
            loginClassName = '',
            modalName = '',
            translations = {},
            activeLanguageCode = 'en',
            recoverLoginUrl = '',
        } = this.props;
        const { isLoading } = this.state;

        const translation = Object.keys(translations).length ? translations : getDefaultTranslation(activeLanguageCode);
        const iframeClassName = isLoading ? 'is-loading' : null;

        return (
            <TranslatorProvider translations={translation}>
                <Modal
                    name={modalName}
                    modalClassName={modalClassName}
                    overlayClassName={overlayClassName}
                >
                    <LoginComponent
                        casUrl={casUrl}
                        service={service}
                        className={loginClassName}
                    />
                </Modal>
                <Modal
                    name={constants.MODAL_ACCOUNT_RECOVERY}
                    modalClassName="account-recovery__modal"
                    onClose={this.accountRecoveryModalClosed}
                >
                    {isLoading && <Spinner className="account-recovery__modal__spinner" />}
                    <iframe
                        src={this.removeCloseBtn(recoverLoginUrl)}
                        onLoad={this.iframeLoaded}
                        className={iframeClassName}
                    />
                </Modal>
            </TranslatorProvider>
        );
    }
}

export default LoginWrapper;



// WEBPACK FOOTER //
// ./src/main/login-wrapper/login-wrapper.js